function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.30176 16.625C5.30176 16.0727 5.74947 15.625 6.30176 15.625H14.3018C14.854 15.625 15.3018 16.0727 15.3018 16.625C15.3018 17.1773 14.854 17.625 14.3018 17.625H6.30176C5.74947 17.625 5.30176 17.1773 5.30176 16.625Z",
  fill: "#4979C0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.3018 11.625C18.854 11.625 19.3018 12.0727 19.3018 12.625C19.3018 13.1773 18.854 13.625 18.3018 13.625H10.3018C9.74947 13.625 9.30176 13.1773 9.30176 12.625C9.30176 12.0727 9.74947 11.625 10.3018 11.625H18.3018Z",
  fill: "#4979C0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.3018 16.625C16.3018 16.0727 16.7495 15.625 17.3018 15.625H18.3018C18.854 15.625 19.3018 16.0727 19.3018 16.625C19.3018 17.1773 18.854 17.625 18.3018 17.625H17.3018C16.7495 17.625 16.3018 17.1773 16.3018 16.625Z",
  fill: "#4979C0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.30176 11.625C7.85404 11.625 8.30176 12.0727 8.30176 12.625C8.30176 13.1773 7.85404 13.625 7.30176 13.625H6.30176C5.74947 13.625 5.30176 13.1773 5.30176 12.625C5.30176 12.0727 5.74947 11.625 6.30176 11.625H7.30176Z",
  fill: "#4979C0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.30176 3.625C2.6449 3.625 1.30176 4.96815 1.30176 6.625V18.625C1.30176 20.2819 2.6449 21.625 4.30176 21.625H20.3018C21.9586 21.625 23.3018 20.2819 23.3018 18.625V6.625C23.3018 4.96815 21.9586 3.625 20.3018 3.625H4.30176ZM20.3018 5.625H4.30176C3.74947 5.625 3.30176 6.07272 3.30176 6.625V18.625C3.30176 19.1773 3.74947 19.625 4.30176 19.625H20.3018C20.854 19.625 21.3018 19.1773 21.3018 18.625V6.625C21.3018 6.07271 20.854 5.625 20.3018 5.625Z",
  fill: "#4979C0"
});

var SvgLog = function SvgLog(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLog, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/log.97fddc00.svg";
export { ForwardRef as ReactComponent };